var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "client-picker",
    attrs: {
      "aria-label": "Klient"
    }
  }, [!_vm.selectedClient && !_vm.editing ? _c('div', {
    staticClass: "picker-modes"
  }, [_vm.canSearch ? _c('button', {
    attrs: {
      "type": "button",
      "aria-pressed": String(_vm.mode === 'search'),
      "disabled": _vm.disabled || _vm.savingClient
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'search';
      }
    }
  }, [_vm._v("Nájsť klienta")]) : _vm._e(), _vm.canCreate ? _c('button', {
    attrs: {
      "type": "button",
      "aria-pressed": String(_vm.mode === 'create'),
      "disabled": _vm.disabled || _vm.savingClient
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'create';
      }
    }
  }, [_vm._v("Vytvoriť klienta")]) : _vm._e()]) : _vm._e(), _vm.editing || !_vm.selectedClient && _vm.mode === 'create' ? _c('client-details-form', {
    attrs: {
      "client": _vm.editing ? _vm.selectedClient : undefined,
      "broker-id": _vm.brokerId
    },
    on: {
      "saved": _vm.clientSaved,
      "cancel": _vm.cancelForm,
      "busy": function busy($event) {
        _vm.savingClient = $event;
      }
    }
  }) : _vm.selectedClient ? _c('div', {
    staticClass: "picked-client"
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedClient.first_name) + " " + _vm._s(_vm.selectedClient.last_name))]), _vm.visibleEmail(_vm.selectedClient) ? _c('span', [_vm._v(_vm._s(_vm.visibleEmail(_vm.selectedClient)))]) : _vm._e(), _vm.selectedClient.client_profile ? _c('span', [_vm._v(_vm._s(_vm.selectedClient.client_profile.telephone))]) : _vm._e(), _c('div', {
    staticClass: "picker-actions"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function click($event) {
        _vm.editing = true;
      }
    }
  }, [_vm._v("Upraviť údaje")]), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.clearClient
    }
  }, [_vm._v("Zmeniť klienta")])])]) : _vm.canSearch ? _c('div', {
    staticClass: "picker-search"
  }, [_c('div', {
    staticClass: "picker-search-field"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": _vm.searchId
    }
  }, [_vm._v("Meno, email alebo telefón")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "id": _vm.searchId,
      "type": "search",
      "placeholder": "Začnite písať meno alebo kontakt",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }, _vm.queueSearch],
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.search.apply(null, arguments);
      }
    }
  })]), _vm.searching ? _c('p', {
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Vyhľadávam…")]) : _vm.searched && !_vm.clients.length && !_vm.error ? _c('p', {
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Nenašli sme žiadneho klienta." + _vm._s(_vm.canCreate ? ' Môžete vytvoriť nového.' : ''))]) : _vm._e(), _vm._l(_vm.clients, function (client) {
    return _c('div', {
      key: client.id,
      staticClass: "search-result"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(client.first_name) + " " + _vm._s(client.last_name))]), _c('small', [_vm._v(_vm._s(_vm.visibleEmail(client)) + " " + _vm._s(client.client_profile && client.client_profile.telephone))])]), _c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.disabled || _vm.searching
      },
      on: {
        "click": function click($event) {
          return _vm.selectClient(client);
        }
      }
    }, [_vm._v("Vybrať")])]);
  })], 2) : _vm._e(), _vm.error ? _c('p', {
    staticClass: "clientError",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }